
import { emptyArray } from '@kodadot1/minimark/utils'
import { Attribute } from '@kodadot1/minimark/common'
import { NeoButton, NeoSelect, NeoTable, NeoTableColumn } from '@kodadot1/brick'

import { Component, Emit, Prop, mixins } from 'nuxt-property-decorator'
import { formatDistanceToNow } from 'date-fns'

import { tokenIdToRoute } from '@/components/unique/utils'

import AuthMixin from '@/utils/mixins/authMixin'
import MetaTransactionMixin from '@/utils/mixins/metaMixin'
import OfferMixin from '@/utils/mixins/offerMixin'
import PrefixMixin from '@/utils/mixins/prefixMixin'
import SubscribeMixin from '@/utils/mixins/subscribeMixin'

import { notificationTypes, showNotification } from '@/utils/notification'

import { Offer } from './types'

const components = {
  Identity: () => import('@/components/identity/IdentityIndex.vue'),
  CommonTokenMoney: () => import('@/components/shared/CommonTokenMoney.vue'),
  BasicSwitch: () => import('@/components/shared/form/BasicSwitch.vue'),
  NeoTable,
  NeoTableColumn,
  NeoSelect,
  NeoButton,
}

@Component({ components, filters: { formatDistanceToNow } })
export default class OffersUserTable extends mixins(
  PrefixMixin,
  AuthMixin,
  OfferMixin,
  MetaTransactionMixin,
  SubscribeMixin
) {
  @Prop({ type: Array, default: () => emptyArray<Attribute>() })
  public offers!: Offer[]
  protected offersListed = false

  @Prop({ type: String, default: '' }) public ownerId!: string
  @Prop({ type: Boolean, default: false }) public hideToggle!: boolean

  @Emit('offersListUpdate')
  public updateList(data) {
    return data
  }

  public timestampOffer(date) {
    return formatDistanceToNow(new Date(date), { addSuffix: true })
  }

  async withdrawOffer(offer) {
    const { caller, nft } = offer
    try {
      const api = await this.useApi()
      this.initTransactionLoader()
      const cb = api.tx.marketplace.withdrawOffer
      const { id, item } = tokenIdToRoute(nft.id)
      const args = [id, item, caller]
      await this.howAboutToExecute(this.accountId, cb, args, (blockNumber) => {
        const msg = 'your offer has been withdrawn'
        showNotification(
          `[OFFER] Since block ${blockNumber} ${msg}`,
          notificationTypes.success
        )
      })
    } catch (e: any) {
      showNotification(`[OFFER::ERR] ${e}`, notificationTypes.warn)
      this.$consola.error(e)
      this.isLoading = false
    }
  }
}
